import { useState } from 'react';
import styled from 'styled-components';

import { SupplyOrderProductStockVariationDetailsPopup } from '../../SupplyOrders/shared/stockVariation/SupplyOrderProductStockVariationDetailsPopup';
import { ProductsInfoStockVariationTable } from '../../SupplyOrders/shared/stockVariation/ProductsInfoStockVariationTable';

import { StockVariationProductInfo } from '../../SupplyOrders/shared/types';

import { getDayLabels } from '../../SupplyOrders/shared/stockVariation/dayLabels';
import {
    GetManualSupplyOrdersQuery,
    GetManualSupplyOrderSupplierProductsStockVariationQuery,
} from 'data/__generated__';

export const ProductsInfoStockVariation = ({
    isComputed,
    orderingTimes,
    productInfo,
    productStockVariation,
    stock,
    startDate,
    shouldDisplayTooltip,
    shortTimeWindow = null,
}: {
    isComputed: boolean;
    orderingTimes?: GetManualSupplyOrdersQuery['manualSupplyOrders'][number]['supplier']['orderingTimes'];
    productInfo: StockVariationProductInfo;
    productStockVariation: GetManualSupplyOrderSupplierProductsStockVariationQuery['manualSupplyOrderSupplierProductsStockVariation']['supplyOrderStockVariations'][number];
    stock: number;
    startDate?: string | null;
    shouldDisplayTooltip: boolean;
    shortTimeWindow?: number | null;
}) => {
    const {
        computedStockThreshold,
        stockVariation,
        forecasts: { forecastsStoreDry },
    } = productStockVariation;

    const dayLabels = getDayLabels({
        isComputed,
        startDate,
        timeWindow: forecastsStoreDry.length,
        orderingTimes,
    });

    const dayLabelsShort = getDayLabels({
        isComputed,
        startDate,
        timeWindow: shortTimeWindow ?? forecastsStoreDry.length,
        orderingTimes,
    });

    const [displayDetails, toggleDetails] = useState(false);

    return (
        <ProductsInfoStockVariationTableContainer
            $isComputed={isComputed}
            onClick={() => toggleDetails(!displayDetails)}
        >
            <ProductsInfoStockThreshold>
                <div>Réserve</div>
                <div>{computedStockThreshold ?? 'Erreur'}</div>
            </ProductsInfoStockThreshold>
            {/* need this condition to not prerender the popup, as the tooltip is expensive to render */}
            {displayDetails ? (
                <SupplyOrderProductStockVariationDetailsPopup
                    dayLabels={dayLabels}
                    isOpen={displayDetails}
                    isComputed={isComputed}
                    productStockVariation={productStockVariation}
                    setIsOpen={toggleDetails}
                    stock={stock}
                    stockVariation={stockVariation}
                    productInfo={productInfo}
                />
            ) : null}
            <ProductsInfoStockVariationTable
                isComputed={isComputed}
                productStockVariation={productStockVariation}
                startDate={startDate}
                orderingTimes={orderingTimes}
                precalculatedDayLabels={dayLabelsShort}
                shouldDisplayTooltip={shouldDisplayTooltip}
                timeWindow={shortTimeWindow}
            />
        </ProductsInfoStockVariationTableContainer>
    );
};

const ProductsInfoStockVariationTableContainer = styled.div<{ $isComputed: boolean }>`
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-style: ${({ $isComputed }) => $isComputed && 'italic'};
    &:hover {
        cursor: pointer;
    }
`;

const ProductsInfoStockThreshold = styled.div`
    font-size: 12px;
    text-align: center;
    margin-right: 15px;
`;
